export const TabType = {
  home: "/home",
  popular: "/category",
  favorite: "/favorite",
};
